import { render, staticRenderFns } from "./changeMaterialTable.vue?vue&type=template&id=3efa1fce&scoped=true&"
import script from "./changeMaterialTable.vue?vue&type=script&lang=js&"
export * from "./changeMaterialTable.vue?vue&type=script&lang=js&"
import style0 from "./changeMaterialTable.vue?vue&type=style&index=0&id=3efa1fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efa1fce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efa1fce')) {
      api.createRecord('3efa1fce', component.options)
    } else {
      api.reload('3efa1fce', component.options)
    }
    module.hot.accept("./changeMaterialTable.vue?vue&type=template&id=3efa1fce&scoped=true&", function () {
      api.rerender('3efa1fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/changeMaterial/changeMaterialTable.vue"
export default component.exports